import React from "react";

function MotwResults({ results, searchTerm }) {
  return (
    <div>
      {results && results.motw && results.motw.mixes !== 0 && (
        <div className="resultsGroup">
          <div className="sectionTitle">Mix of the Week</div>
          <div className="sectionList">
            <ul>
              {results && results.motw && results.motw.mixes !== 0 && results.motw.results.map(motw => {
                return (
                  <li>
                    »{" "}
                    <a href={`${motw.url}`} target="_blank">
                      {" "}
                      Mix of the Week #{motw.motw}: "{motw.title}" by {motw.dj}
                    </a>
                  </li>
                )
              }

              )}
            </ul>


          </div>
        </div>
      )}
    </div>
  );
}

export default MotwResults;
